import { api } from './api.service';
import { Files } from './journey.service';

export interface IOyanaAddresses {
  cep: string;
  city: string;
  state: string;
  country?: string;
  address: string;
  addressNumber?: number | string | null;
  addressComplement: string;
  addressReference: string;
  neighborhood: string;
}

export type GoogleReviewInteractionType = 'review' | 'close' | 'later';

export interface IGoogleReviewInteraction {
  interactionType: GoogleReviewInteractionType;
  createdAt: string;
}

export interface IOyanaResponse {
  id: string;
  cpf: string;
  firstName: string;
  lastName: string;
  email: string;
  mobileNumber: string;
  birthDate: string;
  nickName: string;
  fullName: string;
  profileImageThumbnail: string;
  addresses: Array<IOyanaAddresses>;
  googleReviewInteraction?: IGoogleReviewInteraction | null;
}

export interface ISingInOTPRequest {
  oyanaid: string;
  code: string;
}

export interface IOyanaAddressResult {
  address: IOyanaAddresses;
  needConfirmAddress: boolean;
}

export const oyana = api.injectEndpoints({
  endpoints: build => ({
    getPersonalData: build.mutation<IOyanaResponse, any>({
      query: () => ({
        url: `/portal/v1/me`
      })
    }),
    getMyPersonalFiles: build.mutation<Files, any>({
      query: () => ({
        url: `/portal/v1/me/files`
      })
    }),
    getMyAddress: build.mutation<IOyanaAddressResult, any>({
      query: () => ({
        url: `/portal/v1/me/address`
      })
    }),
    setMyAddress: build.mutation<any, IOyanaAddresses>({
      query: adress => ({
        url: `/portal/v1/me/address`,
        body: adress,
        method: 'PUT'
      })
    }),
    saveGoogleReviewInteraction: build.mutation<IGoogleReviewInteraction, { interactionType: GoogleReviewInteractionType }>({
      query: body => ({
        url: `/portal/v1/me/google-review-interaction`,
        body,
        method: 'POST'
      })
    })
  })
});

export const {
  useGetPersonalDataMutation,
  useGetMyPersonalFilesMutation,
  useGetMyAddressMutation,
  useSetMyAddressMutation,
  useSaveGoogleReviewInteractionMutation
} = oyana;
